import React from "react";
import ReactDOM from "react-dom";
import "./site.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

document.documentElement.classList.add("js");

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
